import React from 'react';
import { useIsSystemAdmin } from 'hooks/useRoleCheck';

type Props = {
  children: React.ReactNode;
};

/**
 * Renders children only if the current user is a System Administrator.
 * Non-admin users see nothing.
 */
const ReactGridEditorAccessGate: React.FC<Props> = ({ children }) => {
  const isAdmin = useIsSystemAdmin();

  if (!isAdmin) {
    return null;
  }

  return <>{children}</>;
};

export default ReactGridEditorAccessGate;
